// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainPremietermijn =
  (typeof SUREbusinessCommonDomainPremietermijn)[keyof typeof SUREbusinessCommonDomainPremietermijn];

export const SUREbusinessCommonDomainPremietermijn = {
  Maand: 'Maand',
  Kwartaal: 'Kwartaal',
  HalfJaar: 'HalfJaar',
  Jaar: 'Jaar',
} as const;
